import { render, staticRenderFns } from "./derive.vue?vue&type=template&id=1aa88a0e&scoped=true&"
import script from "./derive.vue?vue&type=script&lang=js&"
export * from "./derive.vue?vue&type=script&lang=js&"
import style0 from "./derive.vue?vue&type=style&index=0&id=1aa88a0e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aa88a0e",
  null
  
)

export default component.exports